import TimePicker from './TimePicker';
import DatePicker from './DatePicker';
import { useEffect, useState } from 'react';
import moment from 'moment-timezone';

const ACTIVE_SET = 0;

const setTags = [
    {
        label: '24h',
        days: 1,
    },
    {
        label: '48h',
        days: 2,
    },
    {
        label: 'week',
        days: 7,
    },
    {
        label: 'two weeks',
        days: 14,
    },
    {
        label: 'month',
        days: 30,
    },
];

const START_DATE = new Date();
START_DATE.setDate(START_DATE.getDate() + setTags[ACTIVE_SET].days);

const Deadline = ({ initialDate, setDeadline, setTimeValid, setDateValid }) => {
    const [time, setTime] = useState(new Date(initialDate) || new Date());
    const [date, setDate] = useState(new Date(initialDate) || START_DATE);
    useEffect(() => {
        if (!moment(date).isValid() || !moment(time).isValid()) {
            return;
        }

        setDeadline(
            `${moment(date).format('MM/DD/YYYY')} ${moment(time).format(
                'HH:mm:ss'
            )}`
        );
    }, [time, date]);
    return (
        <>
            <TimePicker
                time={time}
                setTime={setTime}
                setTimeValid={setTimeValid}
            />
            <DatePicker
                date={date}
                setDate={setDate}
                setDateValid={setDateValid}
            />
        </>
    );
};
export default Deadline;
